import React from "react";
import { formatNumber } from "utils/formatNumber.ts";

import { EmptyCell } from "../EmptyCell/EmptyCell.tsx";

interface NumberCellProps {
    amount: number | undefined | null;
    nullFallback?: boolean;
}

export const NumberCell: React.FC<NumberCellProps> = ({ amount, nullFallback = true }) => {
    if (amount === null || amount === undefined) {
        return nullFallback ? <>0</> : <EmptyCell />;
    }
    const n = Number(amount);
    if (!Number.isFinite(n)) {
        return nullFallback ? <>0</> : <EmptyCell />;
    }
    return <>{formatNumber(n)}</>;
};
